import * as React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

export const Copy = () => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.5 1H12.6C14.8402 1 15.9603 1 16.816 1.43597C17.5686 1.81947 18.1805 2.43139 18.564 3.18404C19 4.03969 19 5.15979 19 7.4V14.5M4.2 19H12.3C13.4201 19 13.9802 19 14.408 18.782C14.7843 18.5903 15.0903 18.2843 15.282 17.908C15.5 17.4802 15.5 16.9201 15.5 15.8V7.7C15.5 6.57989 15.5 6.01984 15.282 5.59202C15.0903 5.21569 14.7843 4.90973 14.408 4.71799C13.9802 4.5 13.4201 4.5 12.3 4.5H4.2C3.0799 4.5 2.51984 4.5 2.09202 4.71799C1.71569 4.90973 1.40973 5.21569 1.21799 5.59202C1 6.01984 1 6.57989 1 7.7V15.8C1 16.9201 1 17.4802 1.21799 17.908C1.40973 18.2843 1.71569 18.5903 2.09202 18.782C2.51984 19 3.0799 19 4.2 19Z"
                    stroke="#140B1D"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.00098 1.00002H16.4676C19.4546 1.00002 20.9481 1.00002 22.0889 1.58131C23.0925 2.09264 23.9084 2.90853 24.4197 3.91207C25.001 5.05293 25.001 6.5464 25.001 9.53335V19M5.26764 25H16.0676C17.5611 25 18.3079 25 18.8783 24.7094C19.3801 24.4537 19.788 24.0458 20.0437 23.544C20.3343 22.9736 20.3343 22.2268 20.3343 20.7333V9.93335C20.3343 8.43988 20.3343 7.69314 20.0437 7.12271C19.788 6.62094 19.3801 6.21299 18.8783 5.95733C18.3079 5.66668 17.5611 5.66668 16.0676 5.66668H5.26764C3.77417 5.66668 3.02743 5.66668 2.457 5.95733C1.95524 6.21299 1.54729 6.62094 1.29163 7.12271C1.00098 7.69314 1.00098 8.43988 1.00098 9.93335V20.7333C1.00098 22.2268 1.00098 22.9736 1.29163 23.544C1.54729 24.0458 1.95524 24.4537 2.457 24.7094C3.02743 25 3.77417 25 5.26764 25Z"
                    stroke="#140B1D"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" className="cursor-pointer">
            <path
                d="M4 1h4.733c1.494 0 2.24 0 2.811.29.502.256.91.664 1.165 1.166.291.57.291 1.317.291 2.81V10m-9.867 3h5.4c.747 0 1.12 0 1.406-.145.25-.128.454-.332.582-.583.146-.285.146-.659.146-1.405v-5.4c0-.747 0-1.12-.146-1.406a1.333 1.333 0 0 0-.582-.582c-.286-.146-.659-.146-1.406-.146h-5.4c-.746 0-1.12 0-1.405.146-.25.127-.455.331-.583.582C1 4.347 1 4.72 1 5.467v5.4c0 .746 0 1.12.145 1.405.128.25.332.455.583.583.285.145.659.145 1.405.145Z"
                stroke="#140B1D"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
